const Merch = () => (
    <main>
    <h1>Merch</h1>
    <p>Show your love for Curty’s Kooky with our official T-shirts, mugs, and tote bags.</p>
  </main>
);

export default Merch;